import { MChip } from "@material-dev/insights-portal-ui-components";
import React from "react";
import { useStyles } from "./BetaChipStyles";

function BetaChip() {
  const { classes } = useStyles();
  return <MChip label="BETA" className={classes.betaTag} size="small" />;
}

export default BetaChip;
